export default __webpack_public_path__ + "static/media/heartbeat.abb7f030.svg";